import accountApi from "@/apis/system/accountAPI";
import commonFn from "@/commons/commonFunction";
import axios from "axios";

export default {
  async getConfigInfo(context, payload) {
    try {
      // let res = await httpClient.getAsync({
      // 	url: api.getAPIUrl() + '/info'
      // });

      // if (res.Success) {
      // 	context.commit('updateConfig', res.Data);
      // }

      context.commit("updateConfig", { CurrentDate: new Date() });
    } catch (ex) {
      commonFn.errorLogging("Lỗi lấy thông tin config:: ", ex);
    }
  },
  /**
   * Lấy token
   */
  async getToken(context, payload) {
    context.commit("updateLoading", true);

    //request
    let url = [window._apis.Business, "/account/token"].join('');
    // console.log('url ' + url);
    let res = await axios.get(url, {
      params: payload,
      withCredentials: true
    });

    context.commit("updateLoading", false);

    if (res) {
      let data = res.data;
      data.FirstLogin = true;
      context.commit("updateToken", data);
      return data;
    }
  },
  /**
   * Lấy thông tin phân quyền
   */
  async getPermission(context, payload) {
    context.commit("updateLoading", true);

    //request
    var res = await accountApi.getPermission(payload);

    context.commit("updateLoading", false);

    if (res) {
      context.commit("updatePermission", res);
    }

    return res;
  },

  /**
   * Đăng xuất
   */
  async logoff(context) {
    // await accountApi.logoff();

    //remove token
    localStorage.clear();
    context.commit("removeToken");
  },
  /**
   * remove token
   */
  removeToken(context) {
    //remove token
    context.commit("removeToken");
  },
  /*
   * Lấy trạng thái collapse của left menu 
   */
  getLeftMenuCollapse(context, payload) {
    context.commit("updateLeftMenuCollapse", payload);
  },

  /**
   * Đánh dấu đã hoàn thành getting
   */
  completeGetting(context) {


    context.commit("completeGetting");
  },

  /**
   * fake login
   */
  async login(context, payload) {
    context.commit("updateLoading", true);

    //request
    var res = await accountApi.login(payload);

    if (res) {
      context.commit("updateToken", res);
      return res;
    }
  },
};
